export function init () {
    let $srcChangerElements = $('.js-src-changer');

    $srcChangerElements.each(function(index, element) {
        let $modal = $(this).find('.modal');
        let $elementToChangeSrc = $(this).find('.js-src-changer__element');

        $modal.on('show.bs.modal', function () {
            let newSrc = $elementToChangeSrc.data('src');
            $elementToChangeSrc.attr('src', newSrc);
        })
    });
}
